import { apiFactory } from "../api_factory";

export const woundsClinicalChartApi = apiFactory({
  path: "/api/v4/wound-clinical-charts",
  useGetOverride: true
});
